<template>
  <YhcEFSectionTitle v-if="!$yhcefs.$userInputData.isContainUnavailableArea"
    >家財の選択</YhcEFSectionTitle
  >
</template>
<script lang="ts">
import { YhcEstimateFormFrontService } from '../YhcEstimateFormFrontService'
import YhcEFSectionTitle from './YhcEFSectionTitle.vue'

export default {
  name: 'YhcEFKazaiSectionTitle',
  components: { YhcEFSectionTitle },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
  },
}
</script>
